import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import Dropzone from 'react-dropzone'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import Icon from '../Icon'

import styles from './index.css'

export const ACCEPT_IMAGES = {
  'image/gif': ['.gif'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/svg+xml': ['.svg'],
  'image/webp': ['.webp'],
}

class DropZone extends PureComponent {
  componentDidMount() {
    window?.addEventListener('paste', this.handlePasteAnywhere)
  }

  componentWillUnmount() {
    window?.removeEventListener('paste', this.handlePasteAnywhere)
  }

  handlePasteAnywhere = (event) => {
    if (this.props.allowPaste && !this.props.disabled) {
      const { accept } = this.props
      const acceptedTypes = Object.keys(accept)
      const items = [...(event.clipboardData?.items || event.originalEvent?.clipboardData?.items || [])].filter(
        (item) => item.kind === 'file' && (acceptedTypes.length === 0 || !!accept[item.type]),
      )

      for (const item of items) {
        const file = item.getAsFile()
        if (file) {
          this.props.onDrop([file], [], event)
        }
      }
    }
  }

  renderDefaultContent = (isDragAccept, isDragReject) => {
    let title = 'Arrastra los archivos a esta zona'
    if (this.props.disabled) {
      title = 'Carga bloqueada'
    } else if (isDragReject) {
      title = 'Imposible cargar archivo(s)'
    } else if (isDragAccept) {
      title = 'Archivo(s) correcto(s)'
    }

    return (
      <div className={styles.defaultContent}>
        <div>
          <Icon
            className={cn(styles.icon, isDragAccept && styles.titleCorrect, isDragReject && styles.titleError)}
            name="upload"
          />
        </div>
        <div className={cn(styles.title, isDragAccept && styles.titleCorrect, isDragReject && styles.titleError)}>
          {title}
        </div>
        {!this.props.disabled && this.props.useRootActions && (
          <div className={styles.textAction}>o haz clic para seleccionar</div>
        )}
      </div>
    )
  }

  render() {
    const { accept, children, className, disabled, innerRef, useRootActions, ...props } = this.props

    return (
      <Dropzone
        accept={accept}
        disabled={disabled}
        noClick={!useRootActions}
        noKeyboard={!useRootActions}
        ref={innerRef}
        {...props}
      >
        {({ getInputProps, getRootProps, isDragAccept, isDragReject }) => (
          <div
            {...getRootProps({
              className: cn(
                className,
                styles.wrapper,
                !disabled && !isDragAccept && !isDragReject && styles.normal,
                disabled && styles.disabled,
                isDragAccept && styles.accept,
                isDragReject && styles.reject,
              ),
            })}
          >
            <input {...getInputProps()} />
            {children || this.renderDefaultContent(isDragAccept, isDragReject)}
          </div>
        )}
      </Dropzone>
    )
  }
}

DropZone.propTypes = {
  onDrop: PropTypes.func.isRequired,

  accept: PropTypes.shape({ [PropTypes.string]: PropTypes.arrayOf(PropTypes.string) }),
  allowPaste: PropTypes.bool,
  children: ChildrenSchema,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.shape({ open: PropTypes.func }) }),
  ]),
  useRootActions: PropTypes.bool,
}

DropZone.defaultProps = {
  accept: ACCEPT_IMAGES,
  allowPaste: true,
  children: null,
  className: '',
  disabled: false,
  innerRef: null,
  useRootActions: false,
}

export default DropZone
